<template>
  <v-dialog
    max-width="400"
    v-model="delete_dialog">
    <v-card
      v-if="delete_dialog"
      class="dialog-card">
      <div class="pa-3">
        <ModalHeader
          icon="mdi-alert"
          modalTitle="Are you sure?"
          @close="delete_dialog = false" />
      </div>
      <div
        class="mx-3 pa-3"
        style="background: rgba(0, 0, 0, 0.06); border-radius: 5px">
        <v-card-text>
          This action is irreversible, are you sure you want to delete the role?
        </v-card-text>
      </div>

      <div class="modal-footer">
        <v-btn
          @click="delete_dialog = false"
          variant="flat">
          <v-icon class="mr-2">mdi-arrow-left-circle</v-icon>
          back
        </v-btn>
        <v-spacer />
        <v-btn
          @click="DeleteRole(roleToDelete)"
          :loading="delete_loading"
          variant="flat"
          dark
          style="background-color: var(--inner-background)">
          <v-icon style="font-size: 22px">mdi-trash-can</v-icon>
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
  <v-dialog
    max-width="600px"
    v-model="new_role_dialog">
    <AddRole
      v-on:close="new_role_dialog = false"
      :current_role="selected_role"
      v-if="new_role_dialog" />
  </v-dialog>
  <div style="display: flex">
    <div style="font-weight: bold; font-size: 20px">
      <v-icon class="mr-3">mdi-badge-account-alert</v-icon>
      User Roles
    </div>
    <v-spacer />
    <HelpButton mdx-name="RolesConfig" />
  </div>
  <v-divider class="mt-3" />
  <div class="config-page-body">
    <div style="margin-top: 40px; margin-bottom: 20px">
      <div></div>
      <v-card-subtitle>User Roles</v-card-subtitle>
      <v-divider />
    </div>
    <v-card
      v-for="(role, uid) in deluge.roles"
      :key="(role, uid)"
      class="mb-2 d-flex align-center"
      style="height: 120px; flex: 1 0 auto"
      flat>
      <div class="mx-5">
        <v-icon
          style="font-size: 65px !important"
          x-large>
          {{ role.icon }}
        </v-icon>
      </div>
      <div>
        <v-card-title style="display: flex; align-items: center">
          {{ role.name }}
        </v-card-title>
        <v-card-subtitle>{{ role.description }}</v-card-subtitle>
        <v-card-actions>
          <v-btn
            @click="
              selected_role = role;
              new_role_dialog = true;
            "
            small
            variant="outlined"
            color="warning">
            Edit
          </v-btn>
          <v-btn
            @click="
              delete_dialog = true;
              roleToDelete = role;
            "
            small
            variant="outlined"
            color="red">
            Delete
          </v-btn>
        </v-card-actions>
      </div>
    </v-card>
    <v-divider
      class="mt-3"
      style="margin-bottom: 12px" />
    <div style="display: flex">
      <v-spacer />
      <v-btn
        @click="
          selected_role = false;
          new_role_dialog = true;
        "
        color="primary"
        variant="flat"
        prepend-icon="mdi-plus"
        class="">
        Add Role
      </v-btn>
    </div>
  </div>
</template>
<script setup>
import EditUserModal from './EditUserModal.vue';
import DeleteUserModal from './DeleteUserModal.vue';
import CreateNewUserModal from './CreateNewUserModal.vue';
import ModalHeader from '../Shared/Modals/ModalHeader.vue';
import { ref, onMounted, onBeforeMount, watch } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { deluge } from '@/stores/deluge.js';
import { $http } from '../../stores/http.js';

import AddRole from './AddRole.vue';
import HelpButton from '../Help-Hints/HelpButton.vue';
const delete_dialog = ref(false);
const router = useRouter();
const route = useRoute();
const deleteuser = ref(false);
const edituser = ref(false);
const selected_role = ref(undefined);
const createuser = ref(false);
const current_user = ref(undefined);
const users = ref([]);
const new_role_dialog = ref(false);
const headers = ref([
  {
    text: 'ID',
    align: 'start',
    value: 'id',
  },
  { text: 'Username', value: 'username' },
  { text: 'Email', value: 'email' },
  { text: 'Access Counter', value: 'access_counter' },
]);

const roleToDelete = ref();

onMounted(() => {
  current_user.value = localStorage.getItem('username');
  getUsers();
});
function DeleteUser(user) {
  current_user.value = user;
  deleteuser.value = true;
}
function EditUser(user) {
  current_user.value = user;
  edituser.value = true;
}
async function DeleteRole(role) {
  await $http('DELETE', '/delete_role?uid=' + role.uid);
  delete_dialog.value = false;
}
function getUsers() {
  $http('GET', '/users').then((response) => {
    users.value = JSON.parse(response);
    deleteuser.value = false;
    edituser.value = false;
    createuser.value = false;
  });
}
</script>
<style scoped>
@import './config.css';
</style>
